// @ts-nocheck
import {
    getBackOrdersParameter,
    getDeleteModalIsOpen,
    getPendingQuantity,
    getSelectedBackOrderItem,
    getUpdateModalIsOpen,
} from "@store/Framework/Store/Store/Data/BackOrders/BackOrdersSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useBackOrdersParameter = convertSelectorToHook(getBackOrdersParameter);
export const useDeleteModalIsOpen = convertSelectorToHook(getDeleteModalIsOpen);
export const useUpdateModalIsOpen = convertSelectorToHook(getUpdateModalIsOpen);
export const usePendingQuantity = convertSelectorToHook(getPendingQuantity);
export const useSelectedBackOrderItem = convertSelectorToHook(getSelectedBackOrderItem);
